(function () {
  'use strict';

  // 账户页由 Shopify 托管；只在跳转前保存入口，不在点击时上报 login。
  const INTENT_COOKIE = '_jiniu_login_intent';
  const COOKIE_DOMAIN = 'spelabautoparts.com';
  const INTENT_TTL_SECONDS = 20 * 60;

  function pageType() {
    const value = String(window.jiniuTrackingContext?.pageType || '');
    if (value === 'index') return 'home';
    return ['product', 'collection', 'cart', 'checkout', 'account'].includes(value)
      ? value
      : 'other';
  }

  function isAccountLink(link) {
    try {
      const url = new URL(link.href, window.location.href);
      const path = url.pathname.replace(/\/$/, '');
      const context = window.jiniuTrackingContext || {};
      const accountRoutes = [
        context.accountLoginUrl,
        context.accountUrl,
        context.storefrontLoginUrl,
        '/account',
        '/account/login',
        '/customer_authentication/login'
      ];
      return accountRoutes.some(function (route) {
        if (!route) return false;
        const configuredUrl = new URL(route, window.location.href);
        return configuredUrl.origin === url.origin &&
          configuredUrl.pathname.replace(/\/$/, '') === path;
      }) || (url.hostname === `account.${COOKIE_DOMAIN}` && url.protocol === 'https:');
    } catch (error) {
      return false;
    }
  }

  function entryDetails(link) {
    if (link.closest('.cart-login-paragraph')) {
      return 'cart';
    }
    if (link.closest('.bottom-bar-item')) {
      return 'other';
    }
    if (link.closest('header, .header-action-icons')) {
      return 'header';
    }
    if (link.closest('[role="dialog"], dialog, .login-popup')) {
      return 'popup';
    }
    if (link.closest('footer')) {
      return 'other';
    }
    const sourcePageType = pageType();
    if (sourcePageType === 'checkout') {
      return 'checkout';
    }
    if (sourcePageType === 'account') {
      return 'account_page';
    }
    if (sourcePageType === 'product' || sourcePageType === 'cart') {
      return sourcePageType;
    }
    return 'other';
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) {
      return;
    }
    const link = event.target.closest('a[href]');
    if (!link || !isAccountLink(link)) {
      return;
    }

    const context = window.jiniuTrackingContext || {};
    const entryText = String(link.innerText || link.getAttribute('aria-label') ||
      link.textContent || link.closest('.bottom-bar-item')?.querySelector('.bottom_info span')?.textContent ||
      '').trim().replace(/\s+/g, ' ').slice(0, 100);
    const intent = {
      createdAt: Date.now(),
      auth_entry: entryDetails(link),
      entry_text: entryText,
      storefront_logged_in: Boolean(context.userId),
      theme_id: String(context.themeId ?? ''),
      theme_name: String(context.themeName || '').slice(0, 100)
    };

    document.cookie = `${INTENT_COOKIE}=${encodeURIComponent(JSON.stringify(intent))}; ` +
      `Domain=${COOKIE_DOMAIN}; Path=/; Max-Age=${INTENT_TTL_SECONDS}; SameSite=Lax; Secure`;
  }, { capture: true });
})();
